import { render, staticRenderFns } from "./CreatePerson.vue?vue&type=template&id=5479387c&scoped=true&lang=pug&"
import script from "./CreatePerson.vue?vue&type=script&lang=js&"
export * from "./CreatePerson.vue?vue&type=script&lang=js&"
import style0 from "./CreatePerson.vue?vue&type=style&index=0&id=5479387c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479387c",
  null
  
)

export default component.exports